<ng-template #spinner>
  <mat-progress-spinner color="primary" mode="indeterminate" value="50"></mat-progress-spinner>
</ng-template>
